import type { DocumentDto } from '../../services/api';
import { t, translateDocumentType } from '../../services/i18n';
import { PROPERTY_ICONS, escapeHtml, formatDate } from './property-shared';

export class RcPropertyDocumentsTab extends HTMLElement {
  documents: DocumentDto[] = [];

  render(): void {
    this.innerHTML = `
      <div class="tab-toolbar">
        <button class="btn btn-primary btn-sm" data-action="add-doc">${PROPERTY_ICONS.plus} ${t('document.upload')}</button>
      </div>
      ${this.documents.length === 0
        ? `<div class="empty-state"><p>${t('property.documents.empty')}</p></div>`
        : `<table>
            <thead><tr><th>${t('common.file')}</th><th>${t('common.type')}</th><th>${t('common.expiryDate')}</th><th>${t('common.actions')}</th></tr></thead>
            <tbody>
              ${this.documents.map((document) => `
                <tr>
                  <td>
                    <div class="doc-filename">${escapeHtml(document.fileName)}</div>
                    ${document.tags ? `<div class="text-muted text-sm">${escapeHtml(document.tags)}</div>` : ''}
                  </td>
                  <td><span class="badge badge-info">${escapeHtml(translateDocumentType(document.documentType))}</span></td>
                  <td>${document.expiryDate ? formatDate(document.expiryDate) : '-'}</td>
                  <td>
                    <div class="card-actions">
                      <button class="btn btn-outline btn-sm" data-action="download-doc" data-id="${document.id}">${t('common.download')}</button>
                      <button class="btn btn-danger btn-sm" data-action="delete-doc" data-id="${document.id}">${t('common.delete')}</button>
                    </div>
                  </td>
                </tr>`).join('')}
            </tbody>
          </table>`}
    `;
  }
}

if (!customElements.get('rc-property-documents-tab')) {
  customElements.define('rc-property-documents-tab', RcPropertyDocumentsTab);
}
